/* muné — storefront interactions (cart, drawer, toast, accordions, popup) */
(function(){
  'use strict';
  var money = (window.Shopify && Shopify.money_format) || '${{amount}}';
  function formatMoney(cents){
    var v = (cents/100).toFixed(2);
    return money.replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents/100));
  }

  /* ---------- toast ---------- */
  var toast;
  function showToast(msg){
    if(!toast){
      toast=document.createElement('div');
      toast.className='mune-toast';
      toast.innerHTML='<span style="width:8px;height:8px;border-radius:50%;background:#B4A0D4"></span><span class="mune-toast__msg"></span>';
      document.body.appendChild(toast);
    }
    toast.querySelector('.mune-toast__msg').textContent=msg||'Añadido a la bolsa';
    toast.classList.add('show');
    clearTimeout(toast._t);
    toast._t=setTimeout(function(){toast.classList.remove('show');},1900);
  }

  /* ---------- cart drawer ---------- */
  function openDrawer(){var o=document.getElementById('mune-drawer-overlay'),d=document.getElementById('mune-drawer');if(o)o.classList.add('open');if(d)d.classList.add('open');refreshCart();}
  function closeDrawer(){var o=document.getElementById('mune-drawer-overlay'),d=document.getElementById('mune-drawer');if(o)o.classList.remove('open');if(d)d.classList.remove('open');}

  function updateCount(n){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){el.textContent=n;});
  }

  function renderCart(cart){
    updateCount(cart.item_count);
    var body=document.getElementById('mune-drawer-body');
    var foot=document.getElementById('mune-drawer-foot');
    if(!body) return;
    if(!cart.items.length){
      body.innerHTML='<p style="font-family:var(--sans);font-weight:300;color:#96928A;padding:40px 0;text-align:center">Tu bolsa está vacía.</p>';
      if(foot) foot.style.display='none';
      return;
    }
    if(foot) foot.style.display='block';
    var html='';
    cart.items.forEach(function(it){
      var img=it.image?('<img src="'+it.image.replace(/(\.[^.]+)$/,'_120x$1')+'" alt="" style="width:64px;height:80px;object-fit:cover;border-radius:6px;background:#fff;border:1px solid var(--linea)">'):'<div style="width:64px;height:80px;border-radius:6px;background:#EEEAF3"></div>';
      html+='<div style="display:flex;gap:14px;padding:16px 0;border-bottom:1px solid var(--linea)">'+
        img+
        '<div style="flex:1;min-width:0">'+
          '<div style="font-family:var(--sans);font-size:11px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;color:#96928A">'+(it.vendor||'')+'</div>'+
          '<div class="mune-serif" style="font-size:16px;line-height:1.2;margin-top:2px">'+it.product_title+'</div>'+
          '<div style="display:flex;align-items:center;justify-content:space-between;margin-top:10px">'+
            '<div style="display:flex;align-items:center;border:1px solid var(--linea);border-radius:2px">'+
              '<button data-cart-minus="'+it.key+'" aria-label="Menos" style="width:32px;height:30px;background:none;border:none;font-size:16px;cursor:pointer">−</button>'+
              '<span style="min-width:26px;text-align:center;font-size:13px;font-weight:600">'+it.quantity+'</span>'+
              '<button data-cart-plus="'+it.key+'" aria-label="Más" style="width:32px;height:30px;background:none;border:none;font-size:16px;cursor:pointer">+</button>'+
            '</div>'+
            '<span style="font-family:var(--sans);font-weight:600;font-size:15px">'+formatMoney(it.final_line_price)+'</span>'+
          '</div>'+
        '</div>'+
      '</div>';
    });
    body.innerHTML=html;
    var st=document.getElementById('mune-drawer-subtotal');
    if(st) st.textContent=formatMoney(cart.total_price);
  }

  function refreshCart(){fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(renderCart).catch(function(){});}

  function changeLine(key,qty){
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();}).then(renderCart).catch(function(){});
  }

  function addVariant(id,qty,open){
    if(!id) return;
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:id,quantity:qty||1}]})})
    .then(function(r){return r.json();})
    .then(function(){showToast('Añadido a la bolsa');refreshCart();if(open)openDrawer();})
    .catch(function(){showToast('No se pudo añadir');});
  }

  /* ---------- delegated clicks ---------- */
  document.addEventListener('click',function(e){
    var add=e.target.closest('[data-add-variant]');
    if(add){e.preventDefault();addVariant(add.getAttribute('data-add-variant'),parseInt(add.getAttribute('data-qty')||'1',10),true);return;}
    if(e.target.closest('[data-cart-open]')){e.preventDefault();openDrawer();return;}
    if(e.target.closest('[data-cart-close]')||e.target.id==='mune-drawer-overlay'){closeDrawer();return;}
    var minus=e.target.closest('[data-cart-minus]');
    var plus=e.target.closest('[data-cart-plus]');
    if(minus||plus){
      var key=(minus||plus).getAttribute(minus?'data-cart-minus':'data-cart-plus');
      var span=(minus||plus).parentNode.querySelector('span');
      var cur=parseInt(span.textContent,10)||1;
      changeLine(key, minus?Math.max(0,cur-1):cur+1);
      return;
    }
    var mo=e.target.closest('[data-menu-btn]');if(mo){document.getElementById('mune-mobilenav').classList.add('open');return;}
    if(e.target.closest('[data-mobilenav-close]')){document.getElementById('mune-mobilenav').classList.remove('open');return;}
    /* accordions */
    var acch=e.target.closest('[data-acc-toggle]');
    if(acch){acch.closest('.mune-acc').classList.toggle('open');return;}
    /* product gallery thumbs */
    var thumb=e.target.closest('[data-gallery-thumb]');
    if(thumb){
      var main=document.getElementById('mune-gallery-main');
      if(main){var full=thumb.getAttribute('data-full');if(full){main.innerHTML='<img src="'+full+'" alt="" style="width:100%;height:100%;object-fit:contain">';}}
      thumb.parentNode.querySelectorAll('[data-gallery-thumb]').forEach(function(t){t.style.borderColor='#E4E2DD';});
      thumb.style.borderColor='#B4A0D4';return;
    }
    /* qty steppers on PDP */
    var qm=e.target.closest('[data-qty-minus]'),qp=e.target.closest('[data-qty-plus]');
    if(qm||qp){
      var wrap=(qm||qp).closest('[data-qty-wrap]');var out=wrap.querySelector('[data-qty-val]');
      var addBtn=document.querySelector('[data-pdp-add]');
      var q=parseInt(out.textContent,10)||1;q=qm?Math.max(1,q-1):q+1;out.textContent=q;
      if(addBtn)addBtn.setAttribute('data-qty',q);
      return;
    }
    if(e.target.closest('[data-popup-close]')||e.target.id==='mune-popup-overlay'){closePopup();return;}
  });

  /* ---------- PDP add-to-cart via form ---------- */
  document.addEventListener('submit',function(e){
    var f=e.target.closest('[data-pdp-form]');
    if(f){e.preventDefault();
      var id=f.querySelector('[name="id"]').value;
      var qEl=f.querySelector('[data-qty-val]');var q=qEl?parseInt(qEl.textContent,10):1;
      addVariant(id,q,true);
    }
  });

  /* ---------- welcome popup ---------- */
  function closePopup(){var o=document.getElementById('mune-popup-overlay');if(o)o.classList.remove('open');try{localStorage.setItem('mune_popup_seen','1');}catch(x){}}
  window.muneClosePopup=closePopup;
  function maybePopup(){
    var o=document.getElementById('mune-popup-overlay');if(!o)return;
    /* si acaba de suscribirse, mostrar la confirmación de inmediato */
    if(document.getElementById('mune-popup-posted')){o.classList.add('open');return;}
    var seen;try{seen=localStorage.getItem('mune_popup_seen');}catch(x){seen=null;}
    if(seen)return;
    setTimeout(function(){o.classList.add('open');},2200);
  }

  /* ---------- buscador predictivo ---------- */
  (function(){
    var box=document.getElementById('mune-search');
    if(!box)return;
    var input=box.querySelector('[data-search-input]');
    var results=box.querySelector('[data-search-results]');
    function openS(){box.classList.add('open');setTimeout(function(){if(input)input.focus();},60);}
    function closeS(){box.classList.remove('open');}
    document.addEventListener('click',function(e){
      if(e.target.closest('[data-search-open]')){e.preventDefault();openS();return;}
      if(e.target.closest('[data-search-close]')||e.target===box){closeS();return;}
    });
    document.addEventListener('keydown',function(e){if(e.key==='Escape')closeS();});
    function money(v){
      if(v===undefined||v===null||v==='')return '';
      var n=(''+v).indexOf('.')>=0?parseFloat(v):parseInt(v,10)/100;
      if(isNaN(n))return '';return '$'+n.toFixed(2);
    }
    function esc(s){return (s||'').replace(/[<>&"]/g,function(c){return {'<':'&lt;','>':'&gt;','&':'&amp;','"':'&quot;'}[c];});}
    function render(products,q){
      if(!products.length){results.innerHTML='<div class="mune-search__empty">Sin resultados para “'+esc(q)+'”.</div>';return;}
      var html='';
      products.forEach(function(p){
        var img=(p.featured_image&&p.featured_image.url)?p.featured_image.url:(p.image||'');
        var price=money(p.price);
        html+='<a class="mune-search__item" href="'+p.url+'">'
          +(img?'<img src="'+img+(img.indexOf('?')>=0?'&':'?')+'width=120" alt="">':'<span style="width:46px;height:46px;flex-shrink:0"></span>')
          +'<span style="min-width:0"><span class="mune-search__brand">'+esc(p.vendor)+'</span><br><span class="mune-search__name">'+esc(p.title)+'</span></span>'
          +(price?'<span class="mune-search__price">'+price+'</span>':'')
          +'</a>';
      });
      results.innerHTML=html;
    }
    var t;
    if(input)input.addEventListener('input',function(){
      var q=input.value.trim();clearTimeout(t);
      if(q.length<2){results.innerHTML='';return;}
      t=setTimeout(function(){
        fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6')
          .then(function(r){return r.json();})
          .then(function(d){var ps=(d.resources&&d.resources.results&&d.resources.results.products)||[];render(ps,q);})
          .catch(function(){});
      },220);
    });
  })();

  document.addEventListener('DOMContentLoaded',function(){
    refreshCart();
    maybePopup();
    /* variant selection on PDP */
    document.querySelectorAll('[data-variant-radio]').forEach(function(r){
      r.addEventListener('change',function(){
        var id=r.getAttribute('data-variant-id');
        var price=r.getAttribute('data-variant-price');
        var idIn=document.querySelector('[data-pdp-form] [name="id"]');if(idIn)idIn.value=id;
        var add=document.querySelector('[data-pdp-add]');
        if(add&&price){var lbl=add.querySelector('[data-add-price]');if(lbl)lbl.textContent=price;}
        r.closest('[data-variant-list]').querySelectorAll('[data-variant-card]').forEach(function(c){c.style.borderColor='#E4E2DD';c.style.background='#fff';});
        var card=r.closest('[data-variant-card]');if(card){card.style.borderColor='#B4A0D4';card.style.background='#F2F1EF';}
      });
    });
  });
})();
